import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class HarleyShouldExitFreespins extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        if (record instanceof FreespinRecord) {
            return !record.beenPaid && record.isFreespinsComplete ? Exit.True : Exit.False;
        } else {
            const records = GameState.getCurrentGame().records;
            for(let i = records.length - 2; i >= 0; i--) {
                if (records[i] instanceof FreespinRecord) {
                    return !records[i].beenPaid && (records[i] as FreespinRecord).isFreespinsComplete ? Exit.True : Exit.False;
                }
            }
        }
        return Exit.False;
    }
}
